import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { notificationsImages } from '../../../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../../../../AddEditProductFormComponents/FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_RESALE_AUTHORIZATION_NOTIFICATIONS
        }
        question="What does reseller authorization created notify me about?"
      />
    ),
    answer: (
      <div>
        When a reseller authorization is created by you for a buyer, you will
        receive an email notification regarding its creation.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_RESALE_AUTHORIZATION_NOTIFICATIONS
        }
        question="What does reseller authorization accepted notify me about?"
      />
    ),
    answer: (
      <div>
        When a buyer accepts a reseller authorization sent by you, you will
        receive an email notification regarding it.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_RESALE_AUTHORIZATION_NOTIFICATIONS
        }
        question="What does reseller authorization expired notify me about?"
      />
    ),
    answer: (
      <div>
        When a reseller authorization sent by you to a buyer expires, you will
        receive an email notification regarding it.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_RESALE_AUTHORIZATION_NOTIFICATIONS
        }
        question="What does reseller authorization cancelled notify me about?"
      />
    ),
    answer: (
      <div>
        When a reseller authorization sent by you to a buyer is cancelled by
        you, you will receive an email notification regarding it.
      </div>
    ),
  },
]

interface ResaleAuthorizationNotificationFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const ResaleAuthorizationNotificationFaqs: React.FC<
  ResaleAuthorizationNotificationFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Resale Authorization Notifications"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={notificationsImages}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
